import { useState } from "react";
import { getUserCredential } from "../../lib/cookies";
import { errStatusHandler, POSTAPI } from "../../api-setup/api-helper";
import { useDispatch } from "react-redux";
import { setNewMessage } from "../../redux/actions/setting-actions";
import { 
	SELECT_FEATURE_MODULE,
	INSERT_FEATURE_MODULE,
	UPDATE_FEATURE_MODULE,
	DELETE_FEATURE_MODULE,
} from "../../api-setup/api-endpoints";
import { useHistory } from "react-router-dom";
import { getColumListXML } from "../../lib/common-service";

export default function FeatureModuleService() {
	const history = useHistory();
	const cookiesData = getUserCredential();
	const header = {
		"x-access-token": cookiesData.secretToken,
	}
	const dispatch = useDispatch();
	const [data, setData] = useState([]);
	const [columns, setColumns] = useState([]);
  const [dataCount, setDataCount] = useState(0);
  const [initialLoading, setLoadingState] = useState(false);
	const [loadingState, setLoadState] = useState({
    isSaveData: undefined,
    isDeleteData: undefined,
  });
	const [isAPICalling, setAPICallingState] = useState(false);
  const [originalData, setOriginalData] = useState([]);
  const [visible, setVisible] = useState(false);
  const [noDataFound, setNoDataFound] = useState(false);
  const [dataState, setDataState] = useState();
  const [isRefreshLoading, setRefreshLoading] = useState(false);
	const [confirmationPopup, setConfirmationPopup] = useState({
		title: "Delete",
		desc: "Are you sure you want to delete this record?",
		isVisible: false,
		type: "",
		actionBtn: [],
		data: {},
		action: "Delete",
	});

	// stored feature_module_name in the database with underscore instead of space so we need to replace it with space
	// reason: due to some dtu issue
	const transformFeatureModuleName = (data) => {
		if (!Array.isArray(data)) return data || [];
		return data.map((item) => ({
			...item,
			feature_module_name: item.feature_module_name?.replace(/_/g, " ") || "",
		}));
	};

	const getFeatureModuleDataList = (listData) => {
		return new Promise(function (resolve, reject) {
      POSTAPI(false, SELECT_FEATURE_MODULE, null, header, listData, dispatch).then((res) => {
        if (res) {
          if (res.data.out_parameters.out_ret_code > 0) {
            // setNoDataFound(true);
            setLoadingState(true);
            errStatusHandler(res, history, dispatch);
          }
          const transformedData = transformFeatureModuleName(res.data.row_result);
          transformedData.map((item, idx) => {
            item.rowId = idx;
            return 0;
          });

          setAPICallingState(false);
          setLoadingState(true);
          setVisible(true);
          setData(transformedData);

          setDataCount(res.data.out_parameters.out_total_rows);
          setOriginalData(transformedData);
          let coloumRealod = listData.in_load_type;
          GetColumnXmlListAsync(coloumRealod);
          setNoDataFound(false);
          setRefreshLoading(false);
          resolve(transformedData);
        }
      });
    })
			.then((res) => {
				return res;
			})
			.catch((res) => {
				if (res.data.out_parameters.out_ret_code > 0) {
					dispatch(
						setNewMessage({
							message: res.data.out_parameters.out_error_msg,
							type: "Error",
							show: true,
						})
					);
					errStatusHandler(res, history, dispatch);
				}
			});
	};

	const GetColumnXmlListAsync = async (columnReload) => {
		const reqData = {
			in_tenant_id: cookiesData.out_tenant_id,
			in_filter: "",
			in_filter_db_name: "procare_system",
			in_filter_table_name: "vw_feature_module",
			in_result_name_mstr_key: 0,
			in_event_type_mstr_key: "0",
			in_hide_column: 0,
			in_load_type: columnReload,
		};
		let resData = await getColumListXML(reqData, history, dispatch);
		if (resData) {
			if (reqData.in_load_type === "grid-reload") {
				setColumns(resData);
			}
		}
	};

	const updateFeatureModuleDataAsync = (bodyData) => {
		setRefreshLoading(true);
		return new Promise(function (resolve, reject) {
			POSTAPI(false, UPDATE_FEATURE_MODULE, null, header, bodyData, dispatch).then((res) => {
        setRefreshLoading(false);
        if (res && res.data.out_parameters.out_ret_code === 0) {
          resolve(true);
        } else {
          dispatch(
            setNewMessage({
              message: res?.data.out_parameters.out_error_msg,
              type: "Error",
              show: true,
            })
          );
          resolve([]);
          errStatusHandler(res, history, dispatch);
        }
      });
		})
			.then((res) => {
				return res;
			})
			.catch((res) => {
				if (res.data.out_parameters.out_ret_code > 0) {
					dispatch(
						setNewMessage({
							message: res.data.out_parameters.out_error_msg,
							type: "Error",
							show: true,
						})
					);
					errStatusHandler(res, history, dispatch);
				}
			});
	};

	const addFeatureModuleDataAsync = (bodyData) => {
		setRefreshLoading(true);
		setLoadState({ ...loadingState, isSaveData: false });
		POSTAPI(false, INSERT_FEATURE_MODULE, null, header, bodyData, dispatch).then((res) => {
      if (res.status) {
        setRefreshLoading(false);
        if (res.data.out_parameters.out_ret_code > 0) {
          dispatch(
            setNewMessage({
              message: res.data.out_parameters.out_error_msg,
              type: "Error",
              show: true,
            })
          );
          errStatusHandler(res, history, dispatch);
        } else {
          setLoadState({ ...loadingState, isSaveData: true });
        }
      }
    });
	}

	const deleteFeatureModuleDataAsync = (bodyData) => {
		setRefreshLoading(true);
		return new Promise(function (resolve, reject) {
			POSTAPI(false, DELETE_FEATURE_MODULE, null, header, bodyData, dispatch).then((res) => {
				const totalFeatureModules = bodyData.in_feature_module_mstr_key.length;
				const unSuccessFullCount = res.data.successCount;
				setRefreshLoading(false);

				if (res.data.out_parameters.out_ret_code > 0) {
					let msg = res.data.out_parameters.out_error_msg;

					if (totalFeatureModules !== unSuccessFullCount) {
						msg =
              unSuccessFullCount +
              " Feature Module (" +
              res.data.successName +
              ") out of " +
              totalFeatureModules +
              " " +
              "selected linked to active result name - cannot delete.";

            setLoadState({ ...loadingState, isDeleteData: true });
            setTimeout(function () {
              resolve("success");
            });
					} else {
						setLoadState({ ...loadingState, isDeleteData: false });
            setTimeout(function () {
              resolve("error");
            });
					}

					setConfirmationPopup({
            ...confirmationPopup,
            isVisible: false,
            type: "",
            actionBtn: [],
            data: {},
            action: "",
          });

					dispatch(
            setNewMessage({
              message: msg,
              type: "Error",
              show: true,
            })
          );
				} else {
					setConfirmationPopup({
            ...confirmationPopup,
            isVisible: false,
            type: "",
            actionBtn: [],
            data: {},
            action: "",
          });
          setLoadState({ ...loadingState, isDeleteData: true });
          setTimeout(function () {
            resolve("success");
          });
				}
			});
		})
			.then((res) => {
				return res;
			})
			.catch((res) => {
        if (res.data.out_parameters.out_ret_code > 0) {
          dispatch(
            setNewMessage({
              message: res.data.out_parameters.out_error_msg,
              type: "Error",
              show: true,
            })
          );
          errStatusHandler(res, history, dispatch);
        }
      });
	}

	const exportDataAsync = (bodyData) => {
		setRefreshLoading(true);
		return new Promise(function (resolve, reject) {
			POSTAPI(false, SELECT_FEATURE_MODULE, null, header, bodyData, dispatch).then((res) => {
				setRefreshLoading(false);
				if (res && (res.data.out_parameters.out_ret_code === 0 || res.data.out_parameters.out_ret_code === 2)) {
					const transformedData = transformFeatureModuleName(res.data.row_result);
					resolve(transformedData);
				} else {
					dispatch(
						setNewMessage({
							message: res?.data.out_parameters.out_error_msg,
							type: "Error",
							show: true,
						})
					);
					resolve([]);
					errStatusHandler(res, history, dispatch);
				}
			});
		})
			.then((res) => {
				return res;
			})
			.catch((res) => {
				if (res.data.out_parameters.out_ret_code > 0) {
					dispatch(
						setNewMessage({
							message: res.data.out_parameters.out_error_msg,
							type: "Error",
							show: true,
						})
					);
					errStatusHandler(res, history, dispatch);
				}
			})
	};

	return [
		{
			data,
			columns,
      dataCount,
      setData,
      setColumns,
      isAPICalling,
      initialLoading,
      setAPICallingState,
      originalData,
      visible,
      setVisible,
      setNoDataFound,
      noDataFound,
      dataState,
      loadingState,
      setLoadState,
      setRefreshLoading,
      isRefreshLoading,
      setDataState,
		},
		{
			getFeatureModuleDataList,
			updateFeatureModuleDataAsync,
			addFeatureModuleDataAsync,
			deleteFeatureModuleDataAsync,
			exportDataAsync,
		}
	]
}